// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"957":"1900cd88","991":"1900cd88"}[chunkId] + ".chunk.css";
};